import React from 'react';
import { isEmpty } from 'lodash';

import { Heading } from 'components/heading/Heading';

import { asText } from 'components/rich-text/RichText';
import { PrismicRichText, IPrismicRichText } from 'types/prismicRichtext';

interface IHeadingContainerProps {
  heading: PrismicRichText;
  isColumnLayout?: boolean;
}

export const HeadingContainer = ({ heading, isColumnLayout }: IHeadingContainerProps) => {
  if (isEmpty(heading)) {
    return null;
  }

  return <Heading isColumnLayout={isColumnLayout}>{asText(heading as IPrismicRichText)}</Heading>;
};
